/** SPEC **/
/*******************************************/
/****** 테스트 된 케이스 *******/
// 250213 - packageProductType: SEEDING_VIDEO_CLEAN 이고 paymentProductType: SEEDING_VIDEO_CLEAN 단품인 경우
/******************************************/

/****** 테스트 분기 체크 포인트 *******/
// brand.billingType === FREE/PAID (+FREE는 카드가 없어도 진행되야 함)
// campaign_payments.type= MONTHLY expires_at (패스 여부)
/******************************************/

/****** 장기 목표 *******/
// packageProductType -> brand_payments->product_name => 패키지 묶음명+총 결제액으로 생성 (순수한 카드 결제 1건)
// packageAmount -> 위 package의 수량
// paymentProducts -> 패키지 구성 상품들 -> campaign_payments 등을 각각 생성하고 brand_payments->id 을 입력하여 관계 연결
/******************************************/

import { useState } from 'react';
import API from '../../api';

// redux
import { mapDispatchProps, mapStateToProps } from '../../store/store';
import { connect } from 'react-redux';
import { X } from 'react-feather';
import Button from '../../components/button';
import CardSelect from '../../pages/cards/select';
import { debounce } from '../../helpers/debounce';
import { useLanguage } from '@languages/index';
import { useStripe } from '@stripe/react-stripe-js';
import { BRAND_BILLING_TYPES } from 'store/brand/reducer';
import { PAYMENT_PRODUCT_TYPE } from 'constants/payment';
import { OverlayBrandTaxInvoiceInfoFormResult } from 'components/overlayBrandTaxInvoiceInfoForm';

interface PaymentCreatePropTypes {
  temporaryKey?: any;
  packageProductType: string;
  packageAmount: number;
  paymentProducts: PaymentProductDatum[];
  cashCampaignPaymentData?: Pick<
    OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment'], 
    keyof OverlayBrandTaxInvoiceInfoFormResult['data']['campaignPayment']
  > | null
  // CALLBACK
  onSuccess?: any;
  // REDUX
  brand?: any;
  auth?: any;
  preferences?: any;
  settings?: any;
  setPopup?: (params?: any) => void;
  closePopup?: () => void;
  showSheet?: (params?: any) => void;
  closeSheet?: () => void;
  showModal?: (params?: any) => void;
  closeModal?: () => void;
  showOverlays?: (params?: any) => void;
  closeOverlays?: () => void;
}

export interface PaymentProductDatum {
  productType: string;
  amount: number;
  price: number;
  campaignId?: any;
  productId?: any;
  postingId?: any;
}

const PaymentCreatePackage = (props: PaymentCreatePropTypes) => {
  const stripe = useStripe();
  const language = useLanguage();
  const languageTexts = { ...language.common, ...language.pages.payments };

  const [isPending, setIsPending] = useState(false);
  const [isAgreed, setIsAgreed] = useState(true);

  const getProductName = (productType) => {
    let result = '';
    switch (productType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
        result = languageTexts.create_text_2;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
        result = languageTexts.create_text_3;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        result = languageTexts.create_text_4;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING:
        result = languageTexts.create_text_5;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION:
        result = languageTexts.create_text_16;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_VIDEO_CLEAN:
        result = languageTexts.create_text_clean_video_name;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        result = languageTexts.create_text_6;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS_RECOVER:
        result = languageTexts.create_text_7;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE:
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY:
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_COMMISSION_ONLY:
        result = languageTexts.create_text_17;
        break;
    }
    return result;
  };

  const getProductSubtitle = (productType) => {
    let result = '';
    switch (productType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
        result = languageTexts.create_text_2;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
        result = languageTexts.create_text_3;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        result = languageTexts.create_text_4;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING:
        result = languageTexts.create_text_5;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION:
        result = languageTexts.create_text_16;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_VIDEO_CLEAN:
        result = languageTexts.create_text_clean_video_subtitle;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        result = languageTexts.complete_text_12;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
        result = languageTexts.create_text_6;
        break;

      case PAYMENT_PRODUCT_TYPE.SNS_PASS_RECOVER:
        result = languageTexts.create_text_7;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY:
        result = languageTexts.create_text_21;
        break;

      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE:
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_COMMISSION_ONLY:
        result = languageTexts.create_text_17;
        break;
    }
    return result;
  };

  const getPaymentDetails = () => {
    return props.paymentProducts.map((paymentProduct) => {
      let desc = '';
      switch (paymentProduct.productType) {
        case PAYMENT_PRODUCT_TYPE.SEEDING_PASS:
        case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY:
          desc = `${parseInt(props.brand.priceSeedingPass).toLocaleString()}${
            props.settings.currencyText
          }`;
        default:
          desc = `${paymentProduct.price.toLocaleString()}${
            props.settings.currencyText
          } * ${languageTexts._amount(paymentProduct.amount)}`;
          break;
      }

      return {
        name: getProductName(paymentProduct.productType),
        description: desc,
      };
    });
  };

  const renderTitle = () => {
    return (
      <div className="flex flex-row items-center md:pt-[50px] pb-[30px]">
        <div className="flex flex-row justify-center items-center">
          <span className="text-xl font-bold text-center md:text-start">
            {languageTexts.pay}
          </span>
        </div>

        <div
          className="cursor-pointer items-center absolute right-0 top-0 m-[30px]"
          onClick={() => {
            props.closeOverlays();
          }}
        >
          <div>
            <X size={24} strokeWidth={1} />
          </div>
        </div>
      </div>
    );
  };

  const getProductPrice = (productType, price) => {
    switch (productType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
      case PAYMENT_PRODUCT_TYPE.SEEDING:
        if (props.brand.remainSeedingPass) {
          return 0;
        } else {
          return Math.round(price);
        }
      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
        return Math.round(props.brand.priceSnsInstall);
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY:
        return Math.round(props.brand.priceSeedingPass);
      default:
        return Math.round(price);
    }
  };

  const getProductPriceText = (productType, price) => {
    switch (productType) {
      case PAYMENT_PRODUCT_TYPE.SEEDING_FIRST:
      case PAYMENT_PRODUCT_TYPE.SEEDING:
        if (props.brand.remainSeedingPass) {
          return languageTexts.free;
        } else {
          return languageTexts._price(
            parseInt(price).toLocaleString(),
            props.settings.currencyText,
          );
        }
      default:
        return languageTexts._price(
          parseInt(price).toLocaleString(),
          props.settings.currencyText,
        );
    }
  };

  const getProductPrefix = (productType, price) => {
    const isGettingPaidPerEach = [
      PAYMENT_PRODUCT_TYPE.SEEDING,
      PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION,
      PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
      PAYMENT_PRODUCT_TYPE.SEEDING_INSPECTION_FEE,
      PAYMENT_PRODUCT_TYPE.SEEDING_VIDEO_CLEAN,
    ].includes(productType);

    if (getProductPriceText(productType, price) == languageTexts.free) {
      return '';
    }
    if (isGettingPaidPerEach) {
      if (productType === PAYMENT_PRODUCT_TYPE.SEEDING_VIDEO_CLEAN) {
        return `${languageTexts.create_text_clean_video_per_each} `;
      }
      return `${languageTexts.create_text_per_each} `;
    }
    return '';
  };

  const getProductDescription = (productType) => {
    switch (productType) {
      // case PAYMENT_PRODUCT_TYPE.SEEDING:
      //   return languageTexts._complete_text_total_price(intoKorean(price), amount)
      case PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER:
        return languageTexts._complete_text_14(
          props.brand.activeSeedingPassEndsAt,
        );
      case PAYMENT_PRODUCT_TYPE.SNS_INSTALL:
      case PAYMENT_PRODUCT_TYPE.SNS_PASS:
        return languageTexts._create_text_10(props.settings.durationSnsPass);
      default:
        return '';
    }
  };

  const getPriceTotal = () => {
    let priceTotal = props.paymentProducts.reduce((p, c) => {
      if (getProductPriceText(c.productType, c.price) == languageTexts.free) {
        return p + 0;
      }
      return p + c.price * c.amount;
    }, 0);

    return Math.round(priceTotal);
  };

  const getPriceTotalWithTax = () => {
    return Math.round(getPriceTotal() * 1.1);
  };

  const renderSummary = () => {
    return (
      <>
        <div className="flex flex-col">
          <div className="flex flex-col">
            <div className="flex flex-col gap-[15px]">
              {/* 동동이 이용권: SNS_INSTALL */}
              {/* 뷰티 연간 이용권: SEEDING_PASS_BEAUTY_YEARLY */}
              {/* 제품제공 1회용: SEEDING */}
              {/* 제품 제공 자동 결제 복구: SEEDING_PASS_RECOVER */}
              {/* 동동이 이용권: SNS_INSTALL, SNS_PASS */}
              {/* 사전 검수 비용: SEEDING_INSPECTION_FEE */}
              {props.paymentProducts.map((paymentProduct, idx) => {
                return (
                  <div key={idx} className="flex flex-col">
                    <div className="flex flex-row justify-between">
                      <div className="flex flex-col justify-center">
                        <span className="font-bold text-[15px] tracking-tighter max-w-[120px]">
                          {getProductSubtitle(paymentProduct.productType)}
                        </span>
                      </div>

                      <div className="flex flex-col justify-center gap-1">
                        <span className="text-[15px] tracking-tighter text-right">
                          {`${getProductPrefix(
                            paymentProduct.productType,
                            paymentProduct.price,
                          )}${languageTexts._price(
                            getProductPrice(
                              paymentProduct.productType,
                              paymentProduct.price,
                            ).toLocaleString(),
                            props.settings.currencyText,
                          )}`}
                        </span>

                        {
                          // paymentProduct.productType == PAYMENT_PRODUCT_TYPE.SEEDING ||
                          paymentProduct.productType ==
                            PAYMENT_PRODUCT_TYPE.SEEDING_PASS_RECOVER ||
                          paymentProduct.productType ==
                            PAYMENT_PRODUCT_TYPE.SNS_INSTALL ||
                          paymentProduct.productType ==
                            PAYMENT_PRODUCT_TYPE.SNS_PASS ? (
                            <span className="text-[11px] tracking-tighter text-right text-gray-400">
                              {getProductDescription(
                                paymentProduct.productType,
                              )}
                            </span>
                          ) : null
                        }
                      </div>
                    </div>

                    {paymentProduct.productType ==
                    PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY ? (
                      <div className="flex flex-row mt-[25px]">
                        <div className="border-t border-[#E8E8E8] w-full" />
                      </div>
                    ) : null}
                  </div>
                );
              })}

              <div className="flex flex-row justify-between items-center">
                <div className="flex flex-col justify-center">
                  <span className="font-bold text-[15px] tracking-tighter">
                    {languageTexts.create_text_18}
                  </span>
                </div>

                <div className="flex flex-col justify-center gap-1">
                  <span className="text-[15px] tracking-tighter text-right">
                    {languageTexts.create_text_total_amount(
                      props.packageAmount,
                    )}
                  </span>
                </div>
              </div>
            </div>

            <div className="flex flex-row my-[25px]">
              <div className="border-t border-[#E8E8E8] w-full" />
            </div>

            <div className="flex flex-row justify-between">
              <div className="flex flex-col"></div>
              <div className="flex flex-col">
                <div className="flex flex-row">
                  <div className="flex flex-col">
                    {/* {`(`} */}

                    {getPaymentDetails().map((item, index) => {
                      return (
                        <span
                          key={index}
                          className="text-[12px] text-[#999999] text-right"
                        >
                          {`${item.name} `}
                          {`${item.description}`}
                        </span>
                      );
                    })}

                    {/* {`)`} */}
                  </div>
                </div>
              </div>
            </div>

            <div className="flex flex-col gap-2">
              <div className="flex flex-row justify-between">
                <div className="flex flex-col justify-center">
                  <span className="font-bold text-[15px] tracking-tighter">
                    {languageTexts.create_text_19}
                  </span>
                </div>
                <div className="flex flex-col justify-center gap-1">
                  <span className="text-[15px] tracking-tighter text-right">
                    {languageTexts._price(
                      getPriceTotal().toLocaleString(),
                      props.settings.currencyText,
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-row my-[25px]">
            <div className="border-t border-black w-full" />
          </div>

          <div className="flex flex-row justify-between">
            <span className="font-bold text-[15px] tracking-tighter">
              {languageTexts.complete_text_17}
            </span>
            <span className="font-bold text-[22px] tracking-tighter">
              {languageTexts._price(
                getPriceTotalWithTax().toLocaleString(),
                props.settings.currencyText,
              )}
            </span>
          </div>
        </div>
      </>
    );
  };

  const renderProceedPaymentButton = () => {
    const isActiveCardExists = props.brand.cards && props.brand.cards.length;
    const isFreeBrand = props.brand.billingType === BRAND_BILLING_TYPES.FREE;

    let buttonColor = '#919191';
    if ((isFreeBrand || isActiveCardExists) && isAgreed && !isPending)
      buttonColor = 'BLACK';

    const getText = () => {
      if (isPending) return languageTexts.create_text_13;
      if (!isAgreed) return languageTexts.create_text_14;

      return languageTexts.pay;
    };

    return (
      <div className="fixed md:relative mt-[20px] md:w-auto bottom-0 left-0 right-0 form-submit-button">
        {isFreeBrand && (
          <div className="mb-[4px] text-center text-[14px] text-[#FF4040] font-bold">
            {languageTexts.create_text_cash_brand_warning}
          </div>
        )}
        <Button
          textColor={'WHITE'}
          buttonColor={buttonColor}
          borderColor={buttonColor}
          text={getText()}
          onClick={
            isPending || !isAgreed
              ? () => {}
              : () => {
                  API.Card.index({
                    ...{
                      brandToken: props.auth.token,
                    },
                  })
                    .then((response) => {
                      const fetchedCards = response.data.cards.data;
                      if (
                        !fetchedCards.length &&
                        props.brand.billingType != BRAND_BILLING_TYPES.FREE
                      ) {
                        props.showModal({ text: languageTexts.create_text_15 });
                        setIsPending(false);
                        return false;
                      }

                      if (isPending) return false;
                      setIsPending(true);

                      /*****************************************************/
                      /** MOCK OLD API PARAMS (패키지용 TYPE, API가 아직 없음) **/
                      /*****************************************************/
                      let paymentProceedParams = {
                        temporaryKey: props.temporaryKey,
                        brandToken: props.auth.token,
                        campaignId: undefined,
                        productId: undefined,
                        postingId: undefined,
                        itemType: undefined,
                        amount: undefined,
                        price: undefined, // 메인 상품 단품 가격
                        priceTotal: undefined, // 전체 가격 (주의: 세금 포함)
                        // 이하 현금결제관련
                        taxInvoiceScheduledDate: props.cashCampaignPaymentData?.taxInvoiceScheduledDate,
                        depositScheduledDate: props.cashCampaignPaymentData?.depositScheduledDate,
                      };
                      // 현재는 단품의 경우만 있음
                      if (
                        props.paymentProducts.length === 1 &&
                        props.packageProductType === props.paymentProducts[0].productType &&
                        props.packageAmount === props.paymentProducts[0].amount
                      ) {
                        paymentProceedParams = {
                          ...paymentProceedParams,
                          ...{
                            campaignId: props.paymentProducts[0].campaignId,
                            productId: props.paymentProducts[0].productId,
                            postingId: props.paymentProducts[0].postingId,
                            itemType: props.packageProductType,
                            amount: props.packageAmount,
                            price: getProductPrice(
                              props.paymentProducts[0].productType,
                              props.paymentProducts[0].price,
                            ),
                            priceTotal: getPriceTotalWithTax(),
                            // 이하 현금결제관련
                            taxInvoiceScheduledDate: props.cashCampaignPaymentData?.taxInvoiceScheduledDate,
                            depositScheduledDate: props.cashCampaignPaymentData?.depositScheduledDate,
                          },
                        };
                      } else {
                        // TODO
                        props.showModal({ text: `NOT DEVELOPED CASE!` });
                        return;
                      }
                      /*****************************************************/
                      /*****************************************************/

                      debounce(async () => {
                        try {
                          const response = await API.Payment.proceed(
                            paymentProceedParams,
                          );

                          props.closeOverlays();
                          setTimeout(() => {
                            /******************************/
                            /** MOCK OLD onSuccessParams **/
                            /******************************/
                            let onSuccessParams = {
                              itemType: paymentProceedParams.itemType,
                              amount: paymentProceedParams.amount,
                              price: paymentProceedParams.price,
                              priceTotal: getPriceTotal(), // 주의: 세금 미포함
                              payment: response.data.payment,
                              paymentDetails: getPaymentDetails(),
                              commissionAmount:
                                props.paymentProducts.find(
                                  (pp) =>
                                    pp.productType ===
                                    PAYMENT_PRODUCT_TYPE.SEEDING_COMMISSION,
                                )?.price ?? 0,
                              inspectionFee:
                                props.paymentProducts.find(
                                  (pp) =>
                                    pp.productType ===
                                    PAYMENT_PRODUCT_TYPE.SEEDING_INSPECTION_FEE,
                                )?.price ?? 0,

                              // package 방식 추가 예정?
                              // temporaryKey: props.temporaryKey,
                              // packageProductType: props.packageProductType,
                              // packageAmount: props.packageAmount,
                              // paymentProducts: props.paymentProducts,
                            };
                            props.onSuccess
                              ? props.onSuccess(onSuccessParams)
                              : null;
                          }, 400);

                          setTimeout(() => {
                            setIsPending(false);
                          }, 1000);
                        } catch (paymentResponse) {
                          if (paymentResponse.message == 'requires_action') {
                            props.showModal({
                              text: '현재 이용할 수 없는 카드 입니다. 다른 카드를 이용해주세요.',
                            });
                            return false;

                            // const { error, paymentIntent } = await stripe.confirmCardPayment(
                            //   paymentResponse.data.payment_intent_client_secret
                            // )

                            // if (error) {
                            // props.showModal({ text: error.message })
                            //   return
                            // }

                            // The payment requires additional confirmation
                            // const confirmResponse = await fetch("/your-backend-confirm-route", {
                            //   method: "POST",
                            //   headers: {
                            //     "Content-Type": "application/json",
                            //   },
                            //   body: JSON.stringify({ paymentIntentId: paymentIntent.id }),
                            // })

                            // const confirmResult = await confirmResponse.json()

                            // if (confirmResult.error) {
                            //   console.error(confirmResult.error)
                            //   alert("Payment failed: " + confirmResult.error)
                            // } else {
                            //   alert("Payment successful!")
                            // }

                            return false;
                          }

                          props.showModal({ text: paymentResponse.message });
                          setIsPending(false);
                        }
                      }, 400);
                    })
                    .catch((error) => {
                      setIsPending(false);
                      setTimeout(() => {
                        props.showModal({ text: error.message });
                      }, 400);
                    });
                }
          }
        />
      </div>
    );
  };

  const renderCards = () => {
    return (
      <div className="flex flex-col w-full mt-[40px] max-w-[370px]">
        <CardSelect
          cardsContainerClassName="p-0"
          cardButtonContainerSpaceClassName="pb-1"
          hidePageTitle={true}
        />
      </div>
    );
  };

  const renderActiveSeedingPass = () => {
    let showActiveSeedingPass = false;
    for (const paymentProduct of props.paymentProducts) {
      if (
        [
          PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_SINGLE,
          PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_YEARLY,
          PAYMENT_PRODUCT_TYPE.SEEDING_PASS_BEAUTY_COMMISSION_ONLY,
        ].includes(paymentProduct.productType)
      ) {
        showActiveSeedingPass = true;
        break;
      }
    }

    if (!showActiveSeedingPass) return null;
    if (!props.brand.activeSeedingPassEndsAt) return null;

    return (
      <div className="flex flex-col">
        <div className="flex flex-col items-center justify-center py-[15px] bg-[#F4F4F4]">
          <h3 className="text-[15px] font-bold mb-[5px]">
            {`${
              props.brand.isCategoryFashion ? languageTexts.create_text_25 : ''
            } `}
            {`${
              props.brand.isCategoryBeauty ? languageTexts.create_text_21 : ''
            } `}
            {`${languageTexts.create_text_pass_using}`}
          </h3>
          <p className="text-[15px] text-[#999999]">
            {`${props.brand.activeSeedingPassStartedAt} ~ ${props.brand.activeSeedingPassEndsAt}`}
          </p>
        </div>
        <div className="h-[40px]" />
      </div>
    );
  };

  let containerStyle = '';
  if (props.preferences.isMobile) {
    containerStyle =
      'h-[100dvh] flex flex-col overflow-scroll bg-white w-[100dvw] px-5 py-5';
  } else {
    containerStyle =
      'relative w-full flex flex-col rounded-t-2xl overflow-y-auto max-h-[100dvh] px-[50px] bg-white pb-[50px] w-[480px]';
  }

  return (
    <>
      <div className={`${containerStyle}`}>
        {renderTitle()}
        {renderActiveSeedingPass()}
        {/* {renderProductDurationSelector()} */}
        {renderSummary()}
        {renderCards()}
        {renderProceedPaymentButton()}
      </div>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchProps)(PaymentCreatePackage);
